import { CONDITION_GROUP_LEVELS, IConditionByLevelPreset, IConditionLimitationRules, IConditionPreset } from "../../policy-types";


class ConditionsPreset {
    private _model: IConditionPreset = {} as IConditionPreset;

    constructor(model: IConditionPreset) {
        this._model = ensureValidModelCopy(model);
    } 

    public getPresetByLevel(level: CONDITION_GROUP_LEVELS): IConditionByLevelPreset  {
        return this._model[level].preset;
    }

}

export default ConditionsPreset;

/** laravel serializes empty object as empty array, which causes mobx "out if bounds read: 0" error, therefore we're making sure the model has valid form */
function ensureValidModelCopy(data: IConditionPreset): IConditionPreset {
    const toObject = (v: any) => Object.assign({}, v); 

    const validData: IConditionPreset = {} as IConditionPreset;
    Object.keys(data).forEach(level => {
        const levelPreset = data[level as CONDITION_GROUP_LEVELS].preset;
        validData[level as CONDITION_GROUP_LEVELS] = {
            ...data[level as CONDITION_GROUP_LEVELS],
            preset: {
                ...levelPreset,
                limitations_by_resolution_type: toObject(levelPreset.limitations_by_resolution_type) as IConditionLimitationRules,
            }
        };
    });

    return validData;
}